export const hoverHeight = '50vh';
